import { useParams } from "react-router";
import { useRltWorkOrderShowQuery } from "@/services/backend/rlt/work-orders/api/work-order-api";
import { CalculationComponent } from "@/routes/processes/[processId]/rlt/calculations/[calculationId]/calculation/calculation-route";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function WorkOrderCompletionCalculationRoute() {
  const { workOrderId } = useParams();
  const { data } = useRltWorkOrderShowQuery({ id: workOrderId! });

  return (
    <CalculationComponent
      calculationId={data!.calculationId}
      defaultOpen={false}
      disabled={isImmutable(data!)}
    />
  );
}
